import { render } from "./record2.vue?vue&type=template&id=623de7f0&scoped=true"
import script from "./record2.vue?vue&type=script&lang=js"
export * from "./record2.vue?vue&type=script&lang=js"

import "./record2.vue?vue&type=style&index=0&id=623de7f0&scoped=true&lang=css"
import "./record2.vue?vue&type=style&index=1&id=623de7f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-623de7f0"

export default script